<div class="betslip-edit-state-tabs-and-picks">
    <div class="betslip-edit-state-container">
        <bs-digital-balance-header [inColumn]="inColumn" />
        @if (isUserOnPlayBreak || (hasArcPreBetMessage$ | async)) {
            <div [ngClass]="{ 'arc-betslip-message': !isUserOnPlayBreak }">
                <ms-arc-message [profileData]="profileData$ | async" [featureLocation]="featureLocation.PreBetSlipMessage" />
            </div>
        }
        @if (isSettingsOpened$ | async) {
            <bs-digital-settings (settingsOpened)="onSettingsOpened($event)" />
            <div class="betslip-edit-state__settings-overlay"></div>
        }
        <div #scroller class="betslip-edit-state__scroller betslip-scroller">
            @if (isPanicSliderEnabled && !inColumn && userService.isAuthenticated) {
                <bs-betslip-panicslider />
            }
            <bs-betslip-type-tabs
                *rxLet="tabProps$; let tabProps; strategy: 'native'"
                [isVisible]="!!tabProps.activeBetslipTypes.length"
                [selectedBetslipType]="tabProps.selectedBetslipType"
                [activeBetslipTypes]="tabProps.activeBetslipTypes" />
            @if (!hasOnboarding) {
                <ng-container *rxLet="contentViewModel$; let state">
                    @if (betslipUpsellConfig.modulePosition === 'top') {
                        <bs-upsell-container />
                    }

                    @switch (state.tabProps.selectedBetslipType) {
                        @case (betslipTypes.Single) {
                            <bs-digital-single-bet
                                [pickList]="state.pickList"
                                [oddsDisplayFormat]="oddsDisplayFormat"
                                [removeButtonPosition]="RemoveButtonPosition.Right"
                                [removeButtonStyle]="RemoveButtonStyle.Ex" />
                        }

                        @case (betslipTypes.Combo) {
                            <bs-digital-combo-bet
                                [pickList]="state.pickList"
                                [oddsDisplayFormat]="oddsDisplayFormat"
                                [removeButtonPosition]="RemoveButtonPosition.Right"
                                [removeButtonStyle]="RemoveButtonStyle.Ex" />
                        }

                        @case (betslipTypes.System) {
                            <bs-digital-system-bet
                                [pickList]="state.pickList"
                                [oddsDisplayFormat]="oddsDisplayFormat"
                                [removeButtonPosition]="RemoveButtonPosition.Right"
                                [removeButtonStyle]="RemoveButtonStyle.Ex" />
                        }

                        @case (betslipTypes.Teaser) {
                            <bs-teaser-bet-container [pickList]="state.pickList" [oddsDisplayFormat]="oddsDisplayFormat" />
                        }
                    }

                    @if (betslipUpsellConfig.modulePosition === 'bottom') {
                        <bs-upsell-container />
                    }
                </ng-container>
            }

            @if (onboardingMessage$ | async; as onboardingMessage) {
                <bs-onboarding [message]="onboardingMessage" />
            }
        </div>
        @if (!hasOnboarding) {
            <div class="errors-container">
                <bs-digital-errors [ngClass]="{ displayOnTop: isSettingsOpened$ | async }" />

                @if (!hasComboPreventionError && !hasNewCustomerOfferPick) {
                    <bs-reward-tokens-onboarding-container />
                }
            </div>
        }
        @if (showRewardsNotEligibleMessage() && rewardTokensNotEligibleMessage) {
            <bs-rewards-not-eligible-info [message]="rewardTokensNotEligibleMessage" />
        }
    </div>
</div>
@if (!hasOnboarding) {
    @if (isTeaserBet) {
        <bs-teaser-bet-summary-container [oddsDisplayFormat]="oddsDisplayFormat" />
        <bs-teaser-bet-place-bet-button />
    } @else {
        <div class="betslip-summary__container ng-star-inserted">
            <bs-betslip-odds-action class="pc-text" />
            @if (quickDepositOpen) {
                <bs-quick-deposit [inColumn]="inColumn" [keepOpen]="isProcessing" [trackingSource]="quickDepositSource" />
            }
            <bs-digital-summary [oddsDisplayFormat]="oddsDisplayFormat" [isQuickDepositOpen]="quickDepositOpen" />
            <bs-digital-place-button />
        </div>
    }
}
